let React    = require('react');
let Moment   = require('moment');

import Utils    from 'utils';
import DropDown from 'dropdown';
import Const    from 'fw_const';

let {Tooltip}        = require('pui-react-tooltip');
let {OverlayTrigger} = require('pui-react-overlay-trigger');
// -------------------------------------------------------

/**
 * ヘッダー専用クラス
 */
class Header extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.initState(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  initState(props) {
    this.state = {
      fixed : false,
    };
  }
  // -------------------------------------------------------
  
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }
  // -------------------------------------------------------
  
  handleScroll() {
    let top = document.documentElement.scrollTop;
    if( top == 0 ) top = window.pageYOffset;
    
    let search_height = 0;
    try {
      search_height = document.getElementById('main-search').clientHeight;
    } catch(e) {}
    
    if( top > search_height && this.state.fixed == false ){
      this.setState({ fixed: true });
    }
    if( top <= search_height && this.state.fixed == true ){
      this.setState({ fixed: false });
    }
  }
  // -------------------------------------------------------
  
  /*
   * 出力処理
   */
  render() {
    let notPage = ['login/login','login/domain_error'];
    let hide  = (notPage.indexOf(this.props.page) !== -1) ? 'hide' : 'show';
    let fixed = (this.state.fixed) ? 'fixed' : '';
    
    let header_navi = (this.props.data.navi == undefined) ? '/' : '/'+ this.props.data.navi;
    
    if( this.props.data.header === false ) return null;
    
    return (
      <header className={'moribus-header '+ this.props.data.navi +' '+ hide +' '+ fixed}>
        <a href={header_navi} className="logo-frame">
          <div className="logo-box">
            <div className="mark" />
            <div className="logo" />
          </div>
        </a>
        
        <div className="menu-box">
          <MainMenu data={this.props.data} />
        </div>
      </header>
    );
  }
}
// -------------------------------------------------------

/**
 * メニューボタン
 */
class TaskMenu extends React.Component {
  render() {
    try {
      let userData = this.props.data.data.userData;
      
      // 基本メニュー
      let menu = [];
      console.log(userData.tasks);
      // アカウント詳細
      userData.tasks.map((d, key) => {
        try {
          // アクション設定
          let action = '';
          if( d.mode == 'draft' ) action = '下書きを確認しましょう';
          if( d.mode == 'post_candidate' ) action = '投稿を確認しましょう';
          
          menu.push(
            <li key={key}>
              <a href={d.link_params}>
                <div className="task-body">
                  <div className="project-title">{d.project.title}</div>
                  <div className="task-date">{Moment(d.register_date).format('YYYY/M/D HH:mm')}</div>
                  
                  <div className="profile">
                    <img src={d.influencer.thumbnail} />
                    <div className="message">
                      <p><span>@{d.influencer.insta_id}</span></p>
                      <p>{action}</p>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          );
        } catch(e) {console.log(e)}
      });
      
      if( menu.length == 0 ){
        menu.push(<li key="none"><a>必要なタスクがありません</a></li>);
        return (
          <div className="notifications-button">
            <DropDown data={{
              btn  : <i className="material-icons alert-none">notifications</i>,
              menu : menu,
              key  : 'main-menu',
            }}/>
          </div>
        );
      } else {
        return (
          <div className="notifications-button">
            <DropDown data={{
              btn  : <i className="material-icons">notifications<span className="notice" /></i>,
              menu : menu,
              key  : 'main-menu',
            }}/>
          </div>
        );
      }
    } catch(e) {
      return null;
    }
  }
}
// -------------------------------------------------------

/**
 * メニューボタン
 */
class MainMenu extends React.Component {
  render() {
    try {
      let userData = this.props.data.data.userData;
      
      // 基本メニュー
      let menu = [];
      
      
      if( userData.authority == Const.value.authority.ADMIN ){
        menu.push(<li key="company-setting"><a href="/company-setting" target="_blank">組織設定</a></li>);
      }
      
      menu.push(<li key="logout" className="border"><a href="/logout">ログアウト</a></li>);
      
      return (
        <div className="setting-button">
          <DropDown data={{
            btn  : <i className="material-icons">menu</i>,
            menu : menu,
            key  : 'main-menu',
          }}/>
        </div>
      );
    } catch(e) {
      return null;
    }
  }
}
// -------------------------------------------------------

export default Header;